import * as React from 'react';
import { Page } from '../../../cookbook-ui/Page_SC';
import { Blank } from '../Home/FAQ_SC';
import { FAQDropdown } from '../../../cookbook-ui/custom-components/FAQDropdown/FAQDropdown';
import { FAQs } from '../../../manual-data/FAQs';

export interface Props {}

export const FAQ: React.FC<Props> = () => {
  return (
    <Page>
      <p className="kxi-text-xlarge kxi-text-600">FAQ's</p>
      <br />
      <p>
        If you don't find an answer here feel free to send a &nbsp;
        <a href="https://inmoment.slack.com/messages/the-kitchen-inquiries/" target="_blank" rel="noopener noreferrer">
          slack message
        </a>
        <br />
        <br />
      </p>
      <FAQDropdown data={FAQs} />
      <Blank />
    </Page>
  );
};
